<template>
  <div>
    <page-head :title="title" :btn-list="btnList" @handleBtn="handleBtn"></page-head>
    <div class="content">
      <div class="search">
        <Form>
          <row type="flex" justify="center">
            <i-col span="12" offset="4">
              <FormItem label="不动产业务单号">
                <div class="detail">{{mailInfo.orderNO}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="不动产业务类型">
                <div class="detail">{{mailInfo.orderType}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="不动产单元号">
                <div class="detail">{{mailInfo.estateUnitNO}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="房屋坐落">
                <div class="detail">{{mailInfo.zl}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="收件地址">
                <div class="detail">{{mailInfo.toAddress}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="收件人姓名">
                <div class="detail">{{mailInfo.toUserName}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="收件人手机号码">
                <div class="detail">{{mailInfo.toPhoneNO}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="收件人身份证号码">
                <div class="detail">{{mailInfo.toIdCardNO }}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="邮寄状态">
                <div v-if="mailInfo"
                  class="detail"
                  :style="{color:typeList[mailInfo.expressStatus]?typeList[mailInfo.expressStatus].color:''}"
                >{{mailInfo.expressStatus!=null?typeList[mailInfo.expressStatus].type:''}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="办理时间">
                <div class="detail">{{mailInfo.expressTime && mailInfo.expressTime.substr(0, 19)}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="驳回原因">
                <div class="detail">{{mailInfo.remark}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="快递单号">
                <div class="detail">{{mailInfo.expressNO}}</div>
              </FormItem>
            </i-col>
            <i-col span="12" offset="4">
              <FormItem label="委托书" prop="headPicUrl">
                <!-- <template v-for="item in imgArr"> -->
                  <img
                    class="headPicUrl"
                    :src="mailInfo.picUrl ||require('@/assets/images/default_avatar.jpg')"
                    @click.stop="clickPic(mailInfo.picUrl)"
                  />
                <!-- </template> -->
              </FormItem>
            </i-col>
            <preview-img
              :currentIndex="0"
              :imgArr="showPreview.list"
              v-if="showPreview.show"
              v-on:closePreview="closePreview"
            ></preview-img>
            <Modal @on-visible-change="onVisibleChange" :value="showMailMsg" :title="modalTitle">
              <Input type="text" v-model="checkMailMsg" placeholder="请输入快递单号" />
              <div class="mt-5"></div>
              <div slot="footer">
                <Button style="margin-right:10px" @click="showMailMsg = false">取消</Button>
                <Button type="primary" @click="mail" :loading="isBtbLoading">确定</Button>
              </div>
            </Modal>

            <Modal
              @on-visible-change="onVisibleChange"
              :value="showRejectMsg"
              :title="rejecModalTitle"
            >
              <Input type="textarea" v-model="checkRejectMsg" :rows="10" placeholder="请填写不予邮寄原因" />
              <div slot="footer">
                <Button style="margin-right:10px" @click="showRejectMsg = false">取消</Button>
                <Button type="primary" @click="reject" :loading="isBtbLoading">确定</Button>
              </div>
            </Modal>
          </row>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import api from "../../../api/index";
const { mailListDetail, updataMailInfo } = api;
const MAILMAP = {
  0: {
    expressStatus1: "未邮寄",
  },
  1: {
    expressStatus1: "已邮寄",
  },
  2: {
    expressStatus1: "驳回",
  },
};
export default {
  name: "mailListDetail",
  components: {
    pageHead,
    PreviewImg,
  },
  data() {
    return {
      title: "不动产证书邮寄信息详情",
      checkMailMsg: "",
      checkRejectMsg: "",
      showMailMsg: false,
      showRejectMsg: false,
      isBtbLoading: false,
      pageNum: 1,
      modalTitle: "",
      rejecModalTitle: "",
      mailInfo: {},
      btnList: [
        {
          name: "驳回",
          type: "reject",
        },
        {
          name: "邮寄",
          type: "mail",
        },
      ],
      typeList: [
        {
          index: 0,
          type: "未邮寄",
          color: "#FF7743"
          
        },
        {
          index: 1,
          type: "已邮寄",
          color: "#46BA54"
        },
        {
          index: 2,
          type: "驳回",
          color: "#F33D3D",
        },
      ],
      imgArr: [],
      showPreview: {
        show: 0,
        list: [],
      }, //预览图片
    };
  },
  methods: {
    async getDetail() {
      try {
        let { orderNO } = this.$route.query;
        let res = await this.$get(mailListDetail(orderNO));
        console.log(res);
        if (res.isSucceed && res.rows) {
          this.mailInfo = res.rows[0];
          console.log(this.mailInfo)
        }
      } finally {
      }
    },
    clickPic(val) {
      this.showPreview.list = [];
      console.log(val);
      this.showPreview.list.push({ isHeight: true, path: val });
      console.log(this.showPreview.list);
      this.showPreview.show = 1;
    },
    closePreview() {
      console.log("========closePreview==========");
      this.showPreview.show = 0;
    },
    onVisibleChange(val) {
      if (!val) {
        this.showRejectMsg = false;
        this.showMailMsg = false;
        this.checkMailMsg = "";
        this.checkRejectMsg = "";
      }
    },
    handleBtn(type) {
      if (type == "mail") {
        console.log("mail");
        this.checkMailMsg = "";
        this.modalTitle = "填写快递单号(选填)";
        this.status = 1;
        this.showMailMsg = true;
      } else if (type == "reject") {
        console.log("reject");
        this.rejecModalTitle = "填写不予邮寄原因(必填)";
        this.checkRejectMsg = "";
        this.status = 0;
        this.showRejectMsg = true;
      }
    },
    async mail() {
      this.isBtbLoading = true;
       try {
        let id = this.mailInfo.id;
        console.log(id);
        let res = await this.$post(updataMailInfo, {
          id: id,
          expressNO: this.checkMailMsg,
          expressStatus: 1
        });
        this.showMailMsg = false;
        this.showRejectMsg = false;
        this.$Message.info("操作成功");
        this.getDetail();
      } finally {
        this.isBtbLoading = false;
      }
    },
    async reject() {
      if (!this.checkRejectMsg) {
        return this.$Message.info("请填写驳回原因");
      }
      this.isBtbLoading = true;
       try {
        let id = this.mailInfo.id;
        console.log(id);
        let res = await this.$post(updataMailInfo, {
          id: id,
          remark: this.checkRejectMsg,
          expressStatus: 2
        });
        this.showMailMsg = false;
        this.showRejectMsg = false;
        this.$Message.info("操作成功");
        this.getDetail();
      } finally {
        this.isBtbLoading = false;
      }
    },
  },
  created() {
    this.getDetail();
  },
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.detail {
  color: #666;
}
.headPicUrl {
  display: inline-block;
  height: 80px;
  width: 80px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.success {
  color: #ff7b44;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 530px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .verifyRecord {
    padding-left: 10px;
    margin-bottom: 20px;
    border-left: 3px solid #ff794e;
    height: 16px;
    line-height: 16px;
  }
}
row {
  text-align: center;
}
.mt-5 {
  margin-top: 150px;
}
</style>